import { render, staticRenderFns } from "./DeleteUserDialog.vue?vue&type=template&id=4dcc4c68&scoped=true"
import script from "./DeleteUserDialog.vue?vue&type=script&lang=js"
export * from "./DeleteUserDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcc4c68",
  null
  
)

export default component.exports